import type { Table } from '@tanstack/react-table';
import { Columns, Eye, EyeOff } from 'lucide-react';

import type { ButtonProps } from '@/_components';
import {
  Button,
  Icon,
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
  Text,
} from '@/_components';

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>;
  buttonProps?: ButtonProps;
}

export function DataTableViewOptions<TData>({ table, buttonProps }: DataTableViewOptionsProps<TData>) {
  const hideAbleCols = table
    .getAllColumns()
    .filter((column) => !!(column.columnDef.meta as { name?: string })?.name && column.getCanHide());

  return (
    <Menubar tabIndex={-1}>
      <MenubarMenu>
        <MenubarTrigger>
          <Button tag="div" as={buttonProps?.as || 'contained'} size="sm" iconLeft={Columns} iconClassName="size-4">
            View
          </Button>
        </MenubarTrigger>
        <MenubarContent align="end">
          <Text as="small" className="text-c-card-foreground px-2 pt-0 pb-0 font-bold">
            View Columns
          </Text>
          <MenubarSeparator className="my-2" />
          {hideAbleCols.map((column) => (
            <MenubarItem
              key={column.id}
              className="capitalize"
              onClick={() => column.toggleVisibility(!column.getIsVisible())}
            >
              <Icon icon={column.getIsVisible() ? EyeOff : Eye} className="size-4" />
              <span>{(column.columnDef.meta as { name: string }).name}</span>
            </MenubarItem>
          ))}

          <MenubarSeparator className="my-2" />

          <MenubarItem
            className="capitalize"
            onClick={() => {
              hideAbleCols.forEach((c) => c.toggleVisibility(false));
            }}
          >
            <Icon icon={EyeOff} className="size-4" />
            <span>Hide All</span>
          </MenubarItem>
          <MenubarItem
            className="capitalize"
            onClick={() => {
              hideAbleCols.forEach((c) => c.toggleVisibility(true));
            }}
          >
            <Icon icon={Eye} className="size-4" />
            <span>Show All</span>
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}
